<template>
  <v-row no-gutters>
    <v-col cols="12" class="pa-2">
        <v-row class="mb-4">

            <v-col
            v-for="(frame, index) in designObject"
            :key="index"
            cols="auto"
            class="pa-1"
            >
            <v-card 
                @click="selectFrame(frame.value)"
                :class="{ 'selected': options.outer_frame === frame.value }"
                class="pattern d-flex align-center justify-center pa-1 cursor-pointer"
                width="69"
                height="69"
                flat
                elevation="5"
            >
                <div 
                    v-if="frame.value === 'none'" 
                    :class="{ 'white-svg': 'none' === frame.value }"
                    >
                  <v-icon large>mdi-cancel</v-icon>
                </div>                                
                <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="58"
                :height="frame.data.label_size ? 54 + frame.data.label_size + 2 + frame.data.label_offset : 54"
                :viewBox="`0 0 24 ${frame.data.label_size ? 24 + frame.data.label_size + 2 + frame.data.label_offset : 24}`"

                :class="{ 'white-svg': options.outer_frame === frame.value }"
                v-html="frame.data.path"
                ></svg>
            </v-card>
            </v-col>

        </v-row>

      <v-text-field
        v-model="options.framelabel"
        :label="'متن قاب'"
        outlined
        dense
        @input="$emit('update', true)"
      ></v-text-field>

      <div class="text-caption grey--text mb-2">{{ 'سایز متن' }}: {{ options['label-text-size'] }}</div>
      <v-slider
        v-model="options['label-text-size']"
        min="10"
        max="200"
        @change="$emit('update', true)"
      ></v-slider>

      <!-- <v-select
        v-model="options.label_font"
        :items="fontOptions"
        :label="'فونت متن'"
        outlined
        dense
        @change="$emit('update', true)"
      ></v-select> -->

      <v-switch
        v-model="options.custom_frame_color"
        true-value="on"
        false-value="off"
        :label="'رنگ سفارشی قاب'"
        @change="$emit('update', true)"
      ></v-switch>

      <div v-if="options.custom_frame_color === 'on'">
        <color-picker
          v-model="options.framecolor"
          :label="'رنگ قاب'"
          @input="$emit('update', true)"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker";

export default {
  name: "qrCodeFrameAdv",
  components: { ColorPicker },
  props: {
    value: Object,
    designObject: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    fontOptions: [
      { text: 'شونم', value: 'Shabnam.ttf' },
      { text: 'وزیر', value: 'Vazir.ttf' },
      { text: 'تنها', value: 'Tanha.ttf' },
      { text: 'یکان', value: 'Yekan.ttf' },
      { text: 'پرستو', value: 'Parastoo.ttf' },
      { text: 'Roboto', value: 'Roboto.ttf' }
    ],

    };
  },
  computed: {
    options: {
      get() { return this.value; },
      set(val) { this.$emit("input", val); },
    },
  },
  methods: {
    selectFrame(value) {
      this.options.outer_frame = value;
      this.$emit('update', true);
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.frame-svg-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.frame-svg-wrapper >>> svg {
  width: 100%;
  height: 60px;
  max-width: 60px;
}
.cursor-pointer {
  cursor: pointer;
}

.pattern {
  border: 1px solid transparent; 
  transition: all 0.3s ease;
}

.pattern:hover {
  border: 1px solid #413199 !important;
  border-radius: 6px;
  background-color: #413199 !important;
  box-shadow: 0 -8px 6px rgba(25, 25, 26, 0.2), 0px 8px 6px rgba(25, 25, 26, 0.2) !important;
}

.pattern.selected {
  border: 1px solid #001554 !important;
  border-radius: 6px;
  background-color: #001554 !important;
  box-shadow: 0 10px 15px #00155423, 0px -10px 15px #00155423 !important;
}

.pattern:hover svg,
.white-svg {
  fill: #ffffff !important;
  color: #ffffff !important;
}
.pattern:hover div {
  color: #ffffff !important;
}
</style>
